import styled from "styled-components";
import zIndexTypes from "../../../../theme/zIndexTypes";
import {
  mediaMaxWidth,
  mediaMaxHeight,
  mediaMinWidth,
} from "../../../utils/mediaQueriesTemplate";

export const Backdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${zIndexTypes.modal};
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxHeight.phone`
    align-items: unset;
  `}

  ${mediaMaxWidth.tablet`
    align-items: unset;
  `}
`;

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 500px;
  height: 470px;
  z-index: ${zIndexTypes.modal};
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop`
    margin-left: unset;
  `}

  ${mediaMaxWidth.tablet`
    top: 10px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 20px);
    padding: 10px 10px;
  `}

  ${mediaMaxHeight.phone`
    top: 10px;
  `}
`;

export const Form = styled.form`
  width: 280px;
  margin: 0 auto;

  svg {
    margin-right: 10px;
  }

  ${mediaMaxWidth.smallDesktop`
    width: 280px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 60px);
  `}
`;

export const Field = styled.div`
  position: relative;
`;

export const TextInput = styled.input`
  font-size: 0.95em;
  width: 280px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(231, 231, 231);
  border-image: initial;
  border-radius: 4px;
  padding: 2px 5px;
  margin: 9px 0;

  &:focus {
    box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset,
      rgba(233, 102, 163, 0.6) 0px 0px 8px;
    border-color: rgb(121, 217, 217);
    outline: none;
  }

  ${mediaMaxWidth.smallDesktop`
    width: 280px;
    padding: 5px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 60px);
  `}
`;

export const Info = styled.div`
  position: absolute;
  bottom: -5px;
  font-size: 0.7em;
  width: 100%;
  text-align: center;
  color: #79D9D9;
  font-weight: 700;
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop`
    width: 95%;
  `}
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const Body = styled.div`
  padding: 10px;
  height: 350px;
  overflow: scroll;
`;

export const Paragraph = styled.p`
  font-style: italic;
  margin-bottom: 10px;
`;

export const Buttons = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  bottom: 10px;
  text-align: center;
`;
